import { render, staticRenderFns } from "./SecurizationArticles.vue?vue&type=template&id=db5e5260"
import script from "./SecurizationArticles.vue?vue&type=script&lang=js"
export * from "./SecurizationArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports